export enum DocGenInteractiveMessages {
	InteractiveFormsReady = "InteractiveFormsReady",
	PolicyFormsGenerated = "PolicyFormsGenerated",
	StatusUpdate = "StatusUpdate"
}
